import { Pipe, PipeTransform } from '@angular/core';
import { getAppUrl } from 'src/app/core/utils/app-utils';

@Pipe({
  name: 'appUrl',
  standalone: false,
})
export class AppUrlPipe implements PipeTransform {
  public transform(subUrl?: string, productId?: string, itemId?: string): string {
    return getAppUrl(subUrl, productId, itemId);
  }
}
